









import {Component, Prop, Vue, Watch} from 'nuxt-property-decorator'
import RadioOption from './RadioOption.vue'

@Component
export default class radios extends Vue {
  public options: RadioOption[] = []

  @Prop({required: true})
  public value!: any

  @Prop({required: false, type: Boolean, default: false})
  public multiselect!: boolean

  mounted ( ) {
    this.reset()
  }

  updated () {
    this.reset()
  }

  reset () {
    this.options = this.$children as RadioOption[]
    this.$on('select', this.select)
    this.markSelected()
  }

  markSelected () {
    if (this.multiselect) {
      this.options.forEach((option) => {
        option.isSelected = this.value.findIndex((v: any) => v === option.value)
      })
    } else {
      this.options.forEach((option) => {
        option.isSelected = this.value === option.value
      })
    }
  }

  select (val: any) {
    if (this.multiselect) {
      const values = this.value.slice(0)
      const index = this.value.findIndex((v: any) => v === val)

      if (index === -1) {
        values.push(val)
      } else {
        values.splice(index, 1)
      }

      this.$emit('input', values)
    } else {
      this.$emit('input', val)
    }
  }
}
